import { DYNAMIC_FORM_CONFIG } from 'src/app/@shared/form/form-config';
import { DYNAMIC_FORM_LIST_LABELS } from 'src/app/@shared/form/dynamic-form-field/dynamic-form-field.config';
import { DynamicFormFieldKey, FormFieldConfig, FormFieldKey } from 'src/app/@shared/form/form.types';
import { FormFieldModel } from 'src/app/@shared/form/form-field/form-field.model';
import { ValidatorFn } from '@angular/forms';

export class DynamicFormFieldModel extends FormFieldModel {
  public listLabel: string;
  public dynamicFieldConfig: {
    icon: string;
    // length = 1 for simple dynamic fields like email, website, etc.
    // length = n for complex dynamic fields like contact person
    fields: FormFieldModel[];
    groupValidators: ValidatorFn[];
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected setDynamicField(key: FormFieldKey, source: FormFieldConfig, translateKey: string): void {
    const fieldConfig = DYNAMIC_FORM_CONFIG[key];

    this.listLabel = DYNAMIC_FORM_LIST_LABELS[key];

    const fields: FormFieldModel[] = Object.keys(fieldConfig).map((subKey: DynamicFormFieldKey) => {
      const subFieldConfig = fieldConfig[subKey];

      return new FormFieldModel(subKey, subFieldConfig, key);
    });

    this.dynamicFieldConfig = {
      fields,
      groupValidators: [],
      icon: this.getIconByKey(key),
    };

    this.setValueType();
  }

  protected setValueType(): void {
    if (this.dynamicFieldConfig.fields.length < 2) {
      this.valueType = 'flatArray';

      return;
    }

    this.valueType = 'nestedArray';
  }

  private getIconByKey(key: FormFieldKey): string {
    let iconName: string;

    switch (key) {
      case 'emails':
        iconName = 'mail-outline';
        break;

      case 'emailsExtended':
        iconName = 'mail-outline';
        break;

      case 'phoneContacts':
        iconName = 'call-outline';
        break;

      case 'websites':
        iconName = 'globe-outline';
        break;

      case 'contactPersons':
        iconName = 'person-outline';
        break;

      case 'contactPersonsFreeText':
        iconName = 'person-outline';
        break;

      default:
        iconName = 'link-outline';
    }

    return iconName;
  }
}
